<div class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">Add Sponsor</h2>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    <div class="row">
      <h3>Sponsor Information</h3>
    </div>

    <div class="row spacing-15">
      <div class="col-12">
        <app-input-component
          [label]="'Sponsor Name'"
          [type]="'text'"
          [placeholder]="'Enter sponsor name'"
          [(value)]="sponsor_name"
        />
      </div>
    </div>

    <div class="row spacing-15">
      <div class="col-12">
        <app-input-component
          [label]="'Sponsor Description'"
          [type]="'text'"
          [placeholder]="'Enter sponsor description'"
          [(value)]="sponsor_description"
        />
      </div>
    </div>

    <div class="row g-4 spacing-30">
      <div class="col-lg-6 col-12">
        <h4>Logo</h4>
        <app-fileorini
          [accept]="'image/*'"
          (filesChanged)="logoFile = $event[0]"
        />
      </div>

      <div class="col-lg-6 col-12">
        <h4>Banner Image</h4>
        <app-fileorini
          [accept]="'image/*'"
          (filesChanged)="imageFile = $event[0]"
        />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-12 d-flex justify-content-end">
        <app-button
          [variant]="'primary'"
          [label]="'Save Sponsor'"
          [iconClass]="'fa fa-plus'"
          (clicked)="onSave()"
        />
      </div>
    </div>
  </div>
</div>
